import { useState, useEffect } from "react";
import React from "react";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import { toast } from "react-toastify";
import ThemeMaker from "../../components/thememaker";
import axios from "axios";
import { tokenDecode } from "../../utils/helper";
import { config } from "../../utils/config";
import { Paginated } from "../../components/Paginated";
import '../../components/table.css';
import styles from "./transaction.module.css";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';
import moment from "moment";
import * as XLSX from 'xlsx';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import "../unsettledTransaction/unsettledTransaction.css";
import MoreVertIcon from '@mui/icons-material/MoreVert';

const { apiEndpoint } = config;

var $ = require('jquery');
const badgeMaker: any = {
    "Created": (order_state: any) => <span className="badge badge-primary">{order_state}</span>,
    "Shipped": (order_state: any) => <span className="badge badge-warning">{order_state}</span>,
    "Delivered": (order_state: any) => <span className="badge badge-success">{order_state}</span>,
    "Canceled": (order_state: any) => <span className="badge badge-danger">{order_state}</span>,
}

const Mstyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "40%",
    maxHeight: "500px",
    overflowY: "auto" as "auto",
    scrollbarWidth: "none",
    bgcolor: 'background.paper',
    border: '1px solid #E5E7EB',
    borderRadius: '20px',
    p: 4,
    '@media (max-width: 600px)': {
        width: '90%',
    },
};

const Transction = () => {
    const decoded: any = tokenDecode();
    const [transactionList, setTransactionList]: any = useState([]);
    const [stransactionList, setStransactionList]: any = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDetailsLoading, setIsDetailsLoading] = useState(false);
    const [Fopen, setFOpen] = useState(false);
    const [Feopen, setFeOpen] = useState(false);
    const [open, setOpen] = useState(false);
    const [Msgopen, setMsgOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleFOpen = () => setFOpen(true);
    const handleFeOpen = () => setFeOpen(true);
    const handleFClose = () => setFOpen(false);
    const handleFeClose = () => setFeOpen(false);
    const handleClose = async () => {
        setOpen(false);
        setCalculation({
            "order_id": "",
            "sellerapp_commission": "",
            "ondc_commission": "",
            "buyer_commission": "",
            "seller_amount": "",
            "order_total": "",
            "tds_deduction": "",
            "tcs_deduction": "",
            "receive_status": 0,
            "settlement_status": "",
            "buyer_commission_percentage": "",
            "gst_on_buyer_commission": "",
            "ONDC_Commissions": "",
            "seller_np_amount": "",
            "seller_np_amount_gst": ""
        });
        settdsValue(0);
        settcsValue(0);
        setsettleClicked(false);
        setTransactionid("");
        setTransactionidDate("");
        setalltransactions([]);
        allTransactionlist();
    };

    const [calculation, setCalculation] = useState({
        "order_id": "",
        "sellerapp_commission": "",
        "ondc_commission": "",
        "buyer_commission": "",
        "seller_amount": "",
        "order_total": "",
        "tds_deduction": "",
        "tcs_deduction": "",
        "receive_status": 0,
        "settlement_status": "",
        "buyer_commission_percentage": "",
        "gst_on_buyer_commission": "",
        "ONDC_Commissions": "",
        "seller_np_amount": "",
        "seller_np_amount_gst": ""
    });

    const { data } = decoded;
    const rawData = {
        seller_id: ''
    };
    const [searchData, setSearchData]: any = useState(rawData);
    const { permission: { category, order, product, role, seller, tax, user } } = data;
    const [sellerList, setSellerList] = useState([]);
    const [valueid, setValueid] = useState("");
    const [valueamount, setValueamount] = useState("");
    const [valuedate, setValuedate] = useState("");
    const [alltransactionData, setalltransactionData] = useState([]);
    const [SelectionParam, setSelectionParam]: any = useState(false);
    const [selectedBox, setselectedBox]: any = useState([]);
    const [Transactionid, setTransactionid]: any = useState("");
    const [TransactionidDate, setTransactionidDate]: any = useState("");
    const [tdsValue, settdsValue] = useState(0);
    const [tcsValue, settcsValue] = useState(0);
    const [alltransactions, setalltransactions] = useState([]);
    const [settleClicked, setsettleClicked] = useState(false);
    const [filterDaata, setfilterDaata] = useState({
        seller_id: "",
        startDate: "",
        endDate: ""
    });
    var count = 1;

    interface State extends SnackbarOrigin {
        sopen: boolean;
    }

    useEffect(() => {
        if (selectedBox.length > 0) {
            handleClick({ vertical: 'top', horizontal: 'center' });
        }
    }, [selectedBox]);

    function filterChangeHandler(e: any) {
        setfilterDaata((prev) => {
            return {
                ...prev, [e.target.name]: e.target.value
            };
        });
    }

    const allTransactionlist = async () => {
        try {
            setIsLoading(true);
            const { data } = await axios({
                url: `${apiEndpoint}/snp/transactions/settled-transaction/1`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                }
            });
            if (data && (data.status === true || data.status === 200)) {
                const list = data.transaction || data.data || [];
                setalltransactions(list);
                setTransactionList(list);
                setStransactionList(list);
                setalltransactionData(list);
            }
        } catch (error) {
            console.log("error", error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchSellerList = async () => {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/transactionStatus`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: {
                    settlement_status: 1
                }
            });
            if (data.status === 200) {
                setIsLoading(false);
                setTransactionList(data.data);
                setalltransactionData(data.data);
            }
        } catch (error) {
            console.log("error", error);
        }
    };

    const getSellerList = async () => {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/getsellerlist`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                }
            });
            if (data && data.status === 200) {
                setSellerList(data.data);
            }
        } catch (error) {
            console.log("error", error);
        }
    };

    const getTransaction = async (order_id: any) => {
        try {
            setIsDetailsLoading(true);
            setCalculation({ ...calculation, order_id });
            const { data } = await axios({
                url: `${apiEndpoint}/snp/transactions/get-calculation`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: {
                    order_id
                }
            });

            if (data && (data.status === true || data.status === 200) && data.data && data.data.length > 0) {
                setCalculation({
                    order_id,
                    "sellerapp_commission": parseFloat(data.data[0].sellerapp_commission || 0).toFixed(2),
                    "ondc_commission": parseFloat(data.data[0].ondc_commission || 0).toFixed(2),
                    "buyer_commission": parseFloat(data.data[0].buyer_commission || 0).toFixed(2),
                    "seller_amount": parseFloat(data.data[0].seller_amount || 0).toFixed(2),
                    "order_total": parseInt(data.data[0].order_total || 0).toFixed(2),
                    "tds_deduction": parseInt(data.data[0].tcs_deduction || 0).toFixed(2),
                    "tcs_deduction": parseInt(data.data[0].tds_deduction || 0).toFixed(2),
                    "receive_status": data.data[0].receive_status,
                    "settlement_status": data.data[0].settlement_status,
                    "buyer_commission_percentage": data.data[0].buyer_commission_percentage,
                    "gst_on_buyer_commission": data.data[0].gst_on_buyer_commission,
                    "ONDC_Commissions": data.data[0].ONDC_Commissions,
                    "seller_np_amount": data.data[0].seller_np_amount,
                    "seller_np_amount_gst": data.data[0].seller_np_amount_gst
                });

                settcsValue(parseInt(data.data[0].tcs_deduction || 0));
                settdsValue(parseInt(data.data[0].tds_deduction || 0));
            } else {
                toast.error(data?.message || "Order calculation not found!");
            }
            setIsDetailsLoading(false);
        } catch (error: any) {
            const apiErrorMessage = error?.response?.data?.message || error?.message || "Something Went Wrong!";
            toast.error(apiErrorMessage);
            setIsDetailsLoading(false);
        }
    };

    async function getFilteredData() {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/filtertransactiondataall`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: {
                    ...filterDaata
                }
            });
            if (data.status === 200) {
                setTransactionList(data.response);
                setStransactionList(data.response);
                setalltransactionData(data.response);
            }
            handleFClose();
        } catch (error) {
            handleFClose();
            console.log("error", error);
        }
    }

    function checkHandler(row: any) {
        let hasId = selectedBox.some((item: any) => item == row.order_id);
        if (!hasId) {
            setselectedBox((prev: any) => {
                return [...prev, row.order_id];
            });
        } else {
            setselectedBox((prev: any) => {
                return prev.filter((item: any) => item !== row.order_id);
            });
        }
    }

    async function submitCheckedDatatoOn() {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/update_settlement`,
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
                method: "POST",
                data: {
                    order_id: [...selectedBox],
                    transaction_id: Transactionid,
                    settlement_status: 1,
                    settlement_date: TransactionidDate
                },
            });

            if (data.status == 200) {
                toast.success("Settled Successfully!", {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                clearSelectionHandler();
            } else {
                toast.error("Error in Settling!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } catch (err) {
            toast.error("Something Went Wrong!", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    async function submitCheckedDataSingle() {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/settlementbyorder`,
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
                method: "POST",
                data: {
                    order_id: calculation?.order_id,
                    transaction_id: Transactionid,
                    settlement_status: 1,
                    settlement_date: TransactionidDate
                },
            });

            if (data.status == 200) {
                toast.success("Settled Successfully!", {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                clearSelectionHandler();
            } else {
                toast.error("Error in Settling!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } catch (err) {
            toast.error("Something Went Wrong!", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    const COLUMNS = [
        !SelectionParam ? {
            Header: "Serial No.",
            Footer: "Serial No.",
            accessor: (row: any, count: any) => {
                return <>{count + 1}</>;
            },
            disableFilters: true,
            sticky: "left"
        } : {
            Header: "Select",
            Footer: "Select",
            accessor: (row: any) => {
                return <input type="checkbox" onChange={() => checkHandler(row)} checked={selectedBox.includes(row.order_id)} />;
            },
            disableFilters: true,
            sticky: "left",
        },
        {
            Header: "Order Id",
            Footer: "Order Id",
            accessor: (a: any) => <span style={{ fontWeight: "700", color: "#0F172A" }}>{a?.order_id}</span>,
            sticky: "left"
        },
        {
            Header: "Seller Name",
            Footer: "Seller Name",
            accessor: "company_name",
            sticky: "left"
        },
        {
            Header: "Total Amount (in Rs)",
            Footer: "Total Amount (in Rs)",
            accessor: (a: any) => <span style={{ fontWeight: "700", color: "#0F172A" }}>₹{parseFloat(a?.order_total || 0).toFixed(0)}</span>,
            sticky: "left"
        },
        {
            Header: "Buyer Commission (in Rs)",
            Footer: "Buyer Commission (in Rs)",
            accessor: (a: any) => { let val = parseFloat(a?.buyer_amt || a?.buyer_amount || 0); return isNaN(val) ? 0 : Math.round(val * 1000) / 1000; },
            sticky: "left"
        },
        {
            id: "settlestatus",
            Header: "Settle Status",
            Footer: "Settle Status",
            accessor: (a: any) => {
                const isSettled = (a?.settlement_status === "1" || a?.settlement_status === 1 || a?.status === 1);
                return (
                    <span style={{
                        backgroundColor: isSettled ? "#DCFCE7" : "#FEF3C7",
                        color: isSettled ? "#15803D" : "#B45309",
                        padding: "5px 14px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        fontWeight: 600,
                        display: "inline-block"
                    }}>
                        {isSettled ? "Settled" : "Not Settled"}
                    </span>
                );
            },
            sticky: "left"
        },
        {
            Header: "Created At",
            Footer: "Created At",
            accessor: (a: any) => a?.created_at ? moment(a.created_at).format("DD-MM-YYYY HH:mm") : "N/A",
            sticky: "left"
        },
        {
            Header: "Action",
            Footer: "Action",
            accessor: (row: any) => {
                return (
                    <button
                        style={{
                            width: "36px",
                            height: "36px",
                            borderRadius: "50%",
                            backgroundColor: "#3B82F6",
                            color: "#FFFFFF",
                            border: "none",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            boxShadow: "0 2px 6px rgba(59, 130, 246, 0.3)",
                            transition: "all 0.2s ease"
                        }}
                        onClick={() => { getTransaction(row.order_id); handleOpen(); }}
                        title="View Details"
                    >
                        <i className="fas fa-eye" style={{ fontSize: "14px" }}></i>
                    </button>
                );
            },
            sticky: "left"
        },
    ];
    count++;

    useEffect(() => {
        getSellerList();
        allTransactionlist();
    }, []);

    async function OrderidSearchHandler(e: any) {
        try {
            const val = e.target.value ? e.target.value.trim() : "";
            if (val === "") {
                allTransactionlist();
            } else {
                setIsLoading(true);
                const { data } = await axios({
                    url: `${apiEndpoint}/snp/transactions/filter-transaction-order-id`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    },
                    data: {
                        status: 1,
                        order_id: val,
                        // seller_id: filterDaata.seller_id || ""
                    }
                });

                if (data && (data.status === 200 || data.status === true)) {
                    let resultList = data.transaction || data.response || data.data || [];
                    if (!Array.isArray(resultList)) {
                        resultList = [resultList];
                    }
                    setTransactionList(resultList);
                } else {
                    setTransactionList([]);
                }
            }
        } catch (error) {
            console.log("Search API error:", error);
            setTransactionList([]);
        } finally {
            setIsLoading(false);
        }
    }

    function inactiveProductHandler() {
        let z = transactionList.filter((item: any) => item);
        let m = z.map((item: any) => item?.order_id);
        setselectedBox(m);
    }

    const [state, setState] = useState<State>({
        sopen: false,
        vertical: 'top',
        horizontal: 'center',
    });

    const { vertical, horizontal, sopen } = state;
    const handleClick = (newState: SnackbarOrigin) => {
        setState({ ...newState, sopen: true });
    };
    const handlesClose = () => {
        setState({ ...state, sopen: false });
    };

    async function clearSelectionHandler() {
        setSelectionParam(false);
        setselectedBox([]);
        handlesClose();
    }

    function getCurrentDate() {
        const today = new Date();
        const year = today.getFullYear();
        let month: string | number = today.getMonth() + 1;
        let day: string | number = today.getDate();

        month = month < 10 ? `0${month}` : month;
        day = day < 10 ? `0${day}` : day;

        return `${year}-${month}-${day}`;
    }

    const action = (
        <div className="d-flex justify-content-between align-items-center" style={{ gap: "10px", padding: "20px" }}>
            <input type="text" className="form-control" placeholder="Transaction ID.." onChange={(e) => { setTransactionid(e.target.value); }} />
            <input type="date" name="" id="" className="form-control bg-white" max={getCurrentDate()} onChange={(e) => { setTransactionidDate(e.target.value); }} />
            <button className=" ml-5 w-50 text-center text-dark mb-1 p-1 " style={{ color: "white", background: "lightgrey", borderRadius: "20px", height: "30px", cursor: "pointer", fontWeight: "700", border: "none" }} disabled={((Transactionid === "") || (TransactionidDate === "")) ? true : false}
                onClick={submitCheckedDatatoOn}
            >
                Settle
            </button>
            <IconButton size="small" aria-label="close" color="inherit" onClick={clearSelectionHandler} style={{ marginLeft: "20px" }}>
                <CloseIcon fontSize="small" />
            </IconButton>
        </div>
    );

    const preventMinus = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    };

    async function receiveHandler() {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/receive_payment`,
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
                method: "POST",
                data: {
                    order_id: calculation?.order_id,
                    tds: tdsValue,
                    tcs: tcsValue,
                    status: 1
                },
            });

            if (data.status == 200) {
                toast.success("Received Successfully!", {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                clearSelectionHandler();
            } else {
                toast.error("Error in Receiving!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } catch (err) {
            toast.error("Something Went Wrong!", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    const exportToExcel = (orders: any) => {
        const headers = [
            'S.No', "Order Id", "Seller Name", "Order Total", "Seller Amount", "Buyer Commission", "Settlement", "TDS", "TCS", "Settled Date", "Order Date"
        ];

        const data = orders.map((order: any, index: any) => {
            return {
                'S.No': index + 1,
                "Order Id": order?.order_id,
                "Seller Name": order.company_name,
                "Order Total": order?.order_total,
                "Seller Amount": order?.seller_amount,
                "Buyer Commission": order?.buyer_commission || order?.buyer_amt,
                "Buyer Commission Percentage": order?.buyer_commission_percentage,
                "Settlement": order?.settlement,
                "TDS": order?.tds,
                "TCS": order?.tcs,
                "Settled Date": order?.settled_date,
                "Order Date": order?.order_date
            };
        });

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(data, { header: headers });
        XLSX.utils.book_append_sheet(wb, ws, 'Orders');
        const fileName = `transactions_${new Date().getTime()}.xlsx`;
        XLSX.writeFile(wb, fileName);
    };

    const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
        props,
        ref,
    ) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const handleMsgClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setMsgOpen(false);
    };

    async function selectSellerHandler(e: any) {
        setfilterDaata((prev) => {
            return { ...prev, seller_id: e.target.value };
        });
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/filtertransactiondataall`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: {
                    seller_id: e.target.value
                }
            });
            if (data.status === 200) {
                setTransactionList(data.response);
                setStransactionList(data.response);
                setalltransactionData(data.response);
            }
            handleFClose();
        } catch (error) {
            handleFClose();
            console.log("error", error);
        }
    }

    const [file, setFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);

    const handleFileChange = (event: any) => {
        const selected = event.target.files?.[0];
        if (selected) {
            setFile(selected);
        }
    };

    const uploadFile = async () => {
        if (!file) {
            toast.error("Please select a file first!");
            return;
        }

        try {
            setIsUploading(true);
            const formData = new FormData();
            formData.append("file", file);

            const { data } = await axios({
                url: `${apiEndpoint}/snp/transactions/upload-csv`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    // Content-Type manually mat lagao, axios FormData ke liye
                    // khud multipart/form-data; boundary=... set kar dega
                },
                data: formData
            });

            if (data?.success === true || data?.status === true || data?.status === 200) {
                toast.success(data?.message || "File uploaded successfully!", {
                    position: "top-right",
                    autoClose: 2000,
                });
                setFile(null);
                handleFeClose();
                allTransactionlist(); // list refresh
            } else {
                toast.error(data?.message || "Upload failed!");
            }
        } catch (error: any) {
            const apiErrorMessage = error?.response?.data?.message || "Something Went Wrong while uploading!";
            toast.error(apiErrorMessage);
        } finally {
            setIsUploading(false);
        }
    };

    const [isExporting, setIsExporting] = useState(false);
    async function exportTransactionHandler(status = 0) {
        try {
            setIsExporting(true);
            const response = await axios({
                url: `${apiEndpoint}/snp/transactions/export-transaction`,
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${sessionStorage.getItem('token')}`,
                    "Content-Type": "application/json"
                },
                data: { status },
                responseType: "blob"
            });

            // Check if response is actually a JSON error message
            if (response.data instanceof Blob) {
                const text = await response.data.text();
                try {
                    const parsed = JSON.parse(text);
                    if (parsed?.status === false || parsed?.message) {
                        toast.error(parsed.message || "No transactions found for the selected filters!");
                        return;
                    }
                } catch (_) {
                    // Valid binary Excel file, proceed to download
                }
            } else if (typeof response.data === "string") {
                try {
                    const parsed = JSON.parse(response.data);
                    if (parsed?.status === false || parsed?.message) {
                        toast.error(parsed.message || "No transactions found for the selected filters!");
                        return;
                    }
                } catch (_) { }
            } else if (response.data && typeof response.data === "object") {
                if (response.data.status === false || response.data.message) {
                    toast.error(response.data.message || "No transactions found for the selected filters!");
                    return;
                }
            }

            const contentType = response.headers?.["content-type"] || "";
            const blob = new Blob([response.data], {
                type: contentType || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", `Settled transactions_${new Date().getTime()}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(downloadUrl);

            toast.success("Exported Successfully!", {
                position: "top-right",
                autoClose: 2000,
            });
        } catch (error: any) {
            let errorMsg = "Something Went Wrong while exporting!";
            try {
                if (error?.response?.data instanceof Blob) {
                    const errText = await error.response.data.text();
                    const errJson = JSON.parse(errText);
                    errorMsg = errJson?.message || errJson?.error || errText || errorMsg;
                } else if (error?.response?.data?.message) {
                    errorMsg = error.response.data.message;
                } else if (error?.response?.data?.error) {
                    errorMsg = error.response.data.error;
                } else if (error?.message) {
                    errorMsg = error.message;
                }
            } catch (_) { }
            toast.error(errorMsg);
        } finally {
            setIsExporting(false);
        }
    }

    return (
        <>
            <ThemeMaker>
                <div className="row w-100 m-0 mt-1">
                    <div className="col-md-12 ">
                        <div className="card shadow-sm border border-light p-3" style={{ borderRadius: "20px", borderColor: "#E5E7EB", backgroundColor: "#ffffff", boxShadow: "0 10px 30px rgba(15, 23, 42, 0.04)", position: "sticky", top: "10px", zIndex: 30 }}>
                            <div className="py-2">
                                <div className={`d-flex justify-content-between p-2 align-items-center flex-wrap ${styles.headerContainer}`} style={{ gap: "15px" }}>
                                    <h4 className="font-weight-bold m-0" style={{ color: "#0F172A", fontSize: "24px" }}>
                                        Settled   Transactions
                                    </h4>

                                    <div className="d-flex align-items-center flex-wrap" style={{ gap: "15px" }}>
                                        {(decoded?.data?.user?.seller_id <= 1 && decoded?.data?.user?.parent_id <= 1) ? (
                                            <fieldset style={{ border: "1.5px solid #F97316", borderRadius: "10px", padding: "0 12px 6px 12px", margin: 0, height: "46px", backgroundColor: "#FFFFFF" }}>
                                                <legend style={{ width: "auto", padding: "0 6px", fontSize: "11px", color: "#F97316", fontWeight: 600, margin: 0 }}>
                                                    Select Seller
                                                </legend>
                                                <select
                                                    name="seller_id"
                                                    onChange={(e) => { selectSellerHandler(e); }}
                                                    className="border-0 bg-transparent text-dark"
                                                    style={{ outline: "none", fontSize: "14px", cursor: "pointer", marginTop: "-6px" }}
                                                    value={filterDaata.seller_id}
                                                >
                                                    <option value="" disabled>Select seller...</option>
                                                    {sellerList.map((item: any) => (
                                                        <option value={item?.seller_id} key={item?.seller_id}>{item?.company_name}</option>
                                                    ))}
                                                </select>
                                            </fieldset>
                                        ) : null}

                                        <fieldset style={{ border: "1.5px solid #F97316", borderRadius: "10px", padding: "0 12px 6px 12px", margin: 0, height: "46px", backgroundColor: "#FFFFFF" }}>
                                            <legend style={{ width: "auto", padding: "0 6px", fontSize: "11px", color: "#F97316", fontWeight: 600, margin: 0 }}>
                                                Search Order ID
                                            </legend>
                                            <div className="d-flex align-items-center" style={{ marginTop: "-6px" }}>
                                                <i className="fas fa-search mr-2" style={{ fontSize: "13px", color: "#F97316" }}></i>
                                                <input
                                                    type="search"
                                                    name="order_id"
                                                    placeholder="Enter Order ID..."
                                                    className="border-0 bg-transparent text-dark"
                                                    style={{ outline: "none", fontSize: "14px", width: "170px" }}
                                                    onChange={(e: any) => OrderidSearchHandler(e)}
                                                />
                                            </div>
                                        </fieldset>

                                        {(decoded?.data?.user?.seller_id <= 1 && decoded?.data?.user?.parent_id <= 1) ? (
                                            <button className="btn btn-primary" style={{ backgroundColor: "#F97316", borderColor: "#F97316", borderRadius: "10px", height: "46px", padding: "0 20px", fontWeight: 600 }} onClick={handleFOpen}>
                                                Filters
                                            </button>
                                        ) : null}

                                        <button
                                            className="btn"
                                            style={{
                                                border: "1.5px solid #F97316",
                                                color: "#F97316",
                                                backgroundColor: "#FFFFFF",
                                                borderRadius: "10px",
                                                height: "46px",
                                                padding: "0 16px",
                                                fontWeight: 600,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "6px",
                                                boxShadow: "none"
                                            }}
                                            disabled={isExporting}
                                            onClick={() => exportTransactionHandler(1)}
                                        >
                                            <i className={`fas ${isExporting ? "fa-spinner fa-spin" : "fa-file-excel"}`} style={{ fontSize: "14px", color: "#F97316" }}></i>
                                            {isExporting ? "Exporting..." : "Export Transactions"}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="p-0">
                                <div className="table-responsive">
                                    <div className="table-border overflow-hidden" style={{ borderRadius: "16px", border: "1px solid #E5E7EB" }}>
                                        {!isLoading ? <Paginated data={transactionList} columns={COLUMNS as any} /> : <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}><CircularProgress style={{ color: "#F97316" }} /></div>}
                                    </div>

                                    <div className={styles.transactionListing_mobile}>
                                        {transactionList.map((item: any) => {
                                            return <div className="border p-3 bg-white mt-2" style={{ borderRadius: "12px", boxShadow: "0 4px 12px rgba(0,0,0,0.03)" }} key={item?.order_id}>
                                                <div className="d-flex mt-1 align-items-center" style={{ gap: "10px" }}>
                                                    <span className="genericlabel" style={{ width: "28%" }} >Order ID</span>
                                                    <span className="font-weight-bold" style={{ fontSize: "14px", width: '70%', color: "#0F172A" }}>{item?.order_id}</span>
                                                </div>
                                                <div className="d-flex mt-1" style={{ gap: "10px" }}>
                                                    <span className="genericlabel" style={{ width: "28%" }} >Order Total</span>
                                                    <span className="" style={{ fontSize: "14px", width: '70%', color: "#F97316", fontWeight: "600" }}>₹{item?.order_total}</span>
                                                </div>
                                                <div className="d-flex mt-1" style={{ gap: "10px" }}>
                                                    <span className="genericlabel" style={{ width: "28%" }} > Seller Name</span>
                                                    <span className="" style={{ fontSize: "14px", width: '70%' }}>{item?.company_name}</span>
                                                </div>
                                                <div className="mt-2">
                                                    <p style={{ width: "90px", fontWeight: 600, borderRadius: "10px", color: "white", background: "#F97316", padding: "6px", textAlign: "center", cursor: "pointer", margin: 0 }}
                                                        onClick={() => { getTransaction(item.order_id); handleOpen(); }} >View</p>
                                                </div>
                                            </div>;
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={Mstyle}>
                        <div className="modal-header position-relative">
                            <p className="modal-title" style={{ fontSize: "14px", fontWeight: "500", color: "black" }}>Order id: {calculation?.order_id} </p>
                            <button type="button" className="close position-absolute" style={{ right: "0", top: "0" }} onClick={() => handleClose()}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        {!isDetailsLoading ? <TableContainer component={Paper}>
                            <Table sx={{ maxWidth: "100%" }} aria-label="simple table">
                                <TableHead>
                                    <TableRow >
                                        <TableCell align="center" className="bg-light">Order Amount</TableCell>
                                        <TableCell align="center" className="bg-light font-weight-bold" >
                                            <span>&#8377;</span>  {calculation?.order_total}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell align="center" className="bg-light">TDS Deduction</TableCell>
                                        <TableCell align="center" className="bg-light font-weight-bold">
                                            <span>{tdsValue}</span>
                                            {/* <input type="number" className="form-control" min={0} value={tdsValue} onKeyPress={preventMinus} onChange={(e: any) => settdsValue(e.target.value)} /> */}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align="center" className="bg-light">TCS Deduction</TableCell>
                                        <TableCell align="center" className="bg-light font-weight-bold">
                                            <span>{tcsValue}</span>
                                            {/* <input type="number" className="form-control" min={0} value={tcsValue} onKeyPress={preventMinus} onChange={(e: any) => settcsValue(e.target.value)} /> */}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow> <TableCell align="center" className="bg-light">Buyer Commission ({calculation.buyer_commission_percentage}%)</TableCell>
                                        <TableCell align="center" className="bg-light font-weight-bold"> <span>&#8377;</span>  {calculation.buyer_commission}</TableCell>
                                    </TableRow>
                                    <TableRow> <TableCell align="center" className="bg-light">GST On Buyer Commission (18%)</TableCell>
                                        <TableCell align="center" className="bg-light font-weight-bold"> <span>&#8377;</span> {(Math.round(parseFloat(calculation.gst_on_buyer_commission) * 100) / 100).toFixed(2)} </TableCell>
                                    </TableRow>
                                    <TableRow> <TableCell align="center" className="bg-light">Seller NP Commission ({calculation.ONDC_Commissions}%)</TableCell>
                                        <TableCell align="center" className="bg-light font-weight-bold"> <span>&#8377;</span>{(Math.round(parseFloat(calculation.seller_np_amount) * 100) / 100).toFixed(2)} </TableCell>
                                    </TableRow>
                                    <TableRow> <TableCell align="center" className="bg-light">GST on Seller NP amount</TableCell>
                                        <TableCell align="center" className="bg-light font-weight-bold"> <span>&#8377;</span> {(Math.round(parseFloat(calculation.seller_np_amount_gst) * 100) / 100).toFixed(2)}</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell align="center" className="bg-light">Seller Amount</TableCell>
                                        <TableCell align="center" className="bg-light font-weight-bold" > <span>&#8377;</span>  {calculation.seller_amount}</TableCell>
                                    </TableRow>
                                </TableHead>
                            </Table>

                            {/* <div className="d-flex justify-content-end p-2 w-100" style={{ gap: "13px" }}>
                                {!settleClicked ? <>{calculation.receive_status !== 1 && <button className="btn btn-primary" onClick={receiveHandler} >Receive</button>}

                                    {(calculation.settlement_status !== "1" && calculation.receive_status == 1) ? <button className="btn text-white" style={{ backgroundColor: "#F97316", borderColor: "#F97316" }} onClick={() => {
                                        setsettleClicked(true);
                                    }} >Settle</button> : null} </> : null}

                                {
                                    settleClicked ? <div className="d-flex justify-content-center" style={{ gap: "5px" }}>
                                        <input type="text" className="form-control" placeholder="Transaction ID" onChange={(e) => { setTransactionid(e.target.value); }} />
                                        <input type="date" name="" id="" className="form-control bg-white" max={getCurrentDate()} onChange={(e) => { setTransactionidDate(e.target.value); }} />
                                        <button className="btn btn-primary" disabled={((Transactionid === "") || (TransactionidDate === "")) ? true : false} onClick={submitCheckedDataSingle}>Submit</button>
                                    </div> : null
                                }
                            </div> */}
                        </TableContainer> : null}
                        {isDetailsLoading ? <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}><CircularProgress style={{ color: "#F97316" }} /></div> : null}
                    </Box>
                </Modal>

                <Modal open={Fopen}
                    onClose={handleFClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description">

                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content" style={{ minHeight: "200px" }}>
                            <div className="modal-header d-flex justify-content-between">
                                <h5 className="modal-title text-dark genericlabel" id="exampleModalLongTitle"> Filters </h5>
                                <span aria-hidden="true" onClick={handleFClose} style={{ cursor: "pointer" }} ><CloseIcon /></span>
                            </div>

                            <div className="modal-body w-50" >
                                {(decoded?.data?.user?.seller_id === 1 || decoded?.data?.user?.parent_id === 1) ?
                                    <div>
                                        <div className={styles.selectionControl}>
                                            <select name="seller_id" id=""
                                                onChange={filterChangeHandler}
                                                className="form-control mb-3"
                                                value={filterDaata.seller_id}
                                            >
                                                <option value="">Select Seller</option>
                                                {sellerList.map((item: any) => (
                                                    <option value={item?.seller_id} key={item?.seller_id}>{item?.company_name || item?.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    : ""}

                                <div className="d-flex " style={{ gap: "20px" }}>
                                    <div>
                                        <label >Start Date</label>
                                        <input name="startDate" type="date" className="form-control" onChange={filterChangeHandler} value={filterDaata.startDate} max={getCurrentDate()} />
                                    </div>

                                    <div>
                                        <label className="text-dark" >End Date</label>
                                        <input name="endDate" type="date" onChange={filterChangeHandler} className="form-control " value={filterDaata.endDate} max={getCurrentDate()} />
                                    </div>
                                </div>
                            </div>

                            <div className="modal-header d-flex justify-content-end " style={{ gap: "20px" }}>
                                <button className="btn btn-danger" data-dismiss="modal" aria-label="Close" onClick={() => {
                                    window.location.reload();
                                }}>Clear Filter</button>

                                <button className="btn btn-primary" data-dismiss="modal" aria-label="Close"
                                    onClick={getFilteredData}
                                >Apply Filter</button>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal open={Feopen}
                    onClose={handleFeClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description">

                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content" style={{ minHeight: "200px" }}>
                            <div className="modal-header d-flex justify-content-between">
                                <h5 className="modal-title genericlabel" id="exampleModalLongTitle"> Upload CSV </h5>
                                <span aria-hidden="true" onClick={handleFeClose} style={{ cursor: "pointer" }} ><CloseIcon /></span>
                            </div>

                            <div className="modal-body " >
                                <input
                                    key={Feopen ? "open" : "closed"}
                                    type="file"
                                    className="form-control"
                                    onChange={handleFileChange}
                                />
                            </div>

                            <div className="modal-header d-flex justify-content-end " style={{ gap: "20px" }}>
                                <button
                                    className="btn btn-primary"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    disabled={!file || isUploading}
                                    onClick={uploadFile}
                                >
                                    {isUploading ? "Uploading..." : "Upload"}
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </ThemeMaker>

            <div style={{ width: "25%" }}>
                <Snackbar
                    anchorOrigin={{ vertical, horizontal }}
                    open={sopen}
                    sx={{ width: "100%" }}
                    key={vertical + horizontal}
                    action={action}
                />
            </div>

            <Snackbar open={Msgopen} autoHideDuration={20000} onClose={handleMsgClose} key={vertical + horizontal} anchorOrigin={{ vertical, horizontal }}>
                <Alert onClose={handleMsgClose} sx={{ width: '100%', padding: "30px", fontWeight: 600, background: "#105293", fontSize: "18px" }} >
                    To see transactions, Select a seller.
                </Alert>
            </Snackbar>
        </>
    );
};

export default Transction;
